import { useEarningsAftMktEnricher } from 'widgets/corpActions/store/data/earningsAftMktOnTMinus1.ts';
import { useCorporateActionsData } from 'widgets/corpActions/store/data/hooks.ts';

export function useCorporateActionsCapsuleData() {
    const data = useCorporateActionsData();

    const { enrichedSymbolEvents } = useEarningsAftMktEnricher(
        data?.events ?? []
    );

    return enrichedSymbolEvents;
}
